'use client';
import {
  Text,
  HStack,
  Popover,
  PopoverBody,
  PopoverHeader,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react';
import { memo, useRef } from 'react';

import NextImage from 'shared/NextImage';

import plus from 'assets/icons/plus.svg';
import minus from 'assets/icons/minus.svg';

const SeeMoreButton = ({
  dataToDisplay,
  btnContainerProps = null,
  popoverHeader,
  popoverContentProps = null,
}) => {
  const contentRef = useRef(null);

  return (
    <Popover
      placement="bottom-end"
      flip={true}
      preventOverflow={false}
      gutter={20}
      initialFocusRef={contentRef}
      eventListeners={{ scroll: false }}
    >
      {({ isOpen }) => (
        <>
          <PopoverTrigger>
            <HStack gap="8px" cursor="pointer" {...btnContainerProps}>
              <NextImage
                src={isOpen ? minus : plus}
                alt={`Иконка ${isOpen ? 'минуса' : 'плюса'}`}
                w="auto"
                h="auto"
                boxSize="24px"
              />

              <Text
                textStyle="button.secondary"
                textDecoration="underline"
                textUnderlineOffset="0.25em"
                _after={{ content: `'.'`, color: 'bg.accent' }}
              >
                Смотреть все
              </Text>
            </HStack>
          </PopoverTrigger>

          <PopoverContent
            w={{ mobile: '90vw', xms: '342px', tablet: '234px', laptop: '320px' }}
            p={{ mobile: '12px', laptop: '20px' }}
            bgColor="bg.white"
            borderRadius="24px"
            mr={{ mobile: '-25px', laptop: '0' }}
            filter="drop-shadow(0 1px 20px rgba(3, 18, 35, 0.06))"
            _focusVisible={{ outline: 'none' }}
            {...popoverContentProps}
          >
            <PopoverHeader
              textStyle={{ mobile: 'h2', laptop: 'h3' }}
              color="text.steelGray"
              border="none"
              p="0"
              mb="4px"
            >
              {popoverHeader}
            </PopoverHeader>

            <PopoverBody
              ref={contentRef}
              textStyle="h2"
              fontSize={{ laptop: '18px', mobile: '16px' }}
              p="0"
            >
              {dataToDisplay.join(', ')}
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};

export default memo(SeeMoreButton);
